export default __webpack_public_path__ + "static/media/earth_icon.344c2398.png";